import {TextField} from "helpers/forms/fields/TextField";
import {FormattedMessage} from "react-intl";
import {PhoneNumber} from "helpers/StringUtil";
import PhoneDisabledIcon from "@mui/icons-material/PhoneDisabled";
import {IconButton} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import {fieldPropTypes} from './FieldPropTypes';

/**
 * Represents a phone input field component.
 *
 * @component
 * @param {Object} props - The properties of the PhoneField component.
 * @param {Object} props.input - The input object from redux-form.
 * @returns {JSX.Element} - The rendered PhoneField component.
 */
export const PhoneField = (props) => (
  <TextField
    label={<FormattedMessage id="patient.form.phone.label" defaultMessage="Phone"/>}
    endAdornment={
      <PhoneNumber number={props.input.value} errorPlaceholder={<PhoneDisabledIcon/>}>
        <IconButton>
          <PhoneIcon/>
        </IconButton>
      </PhoneNumber>
    }
    {...props}
  />
);
PhoneField.propTypes = {
  ...fieldPropTypes
};
